import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-named-as-default-member
import Header from '../header';
import Footer from '../footer';
import './index.scss';
// import Content from '../../components/content';
import AppContext from '../../context';
import { get } from '../../utils/request';
import {
    BackTop,
} from 'antd';

export default function Page(props) {
    const { children, hideFooter, hideHeaderBg } = props;
    const [userInfo, setUserInfo] = useState({});
    const getSsoResData = async () => {
        const userInfo = await get('/tool/userinfo', {});
        window.sessionStorage.setItem('mis', userInfo.login);
        setUserInfo(userInfo);
    };

    const backToTopStyle = {
        color: '#1088e9',
    };

    useEffect(() => {
        getSsoResData();
    }, []);

    let toolCategoryList = [
        "基础工具",
        "性能工具",
        "视图工具",
        "网络工具",
        "容器工具",
        "基建工具",
        "业务工具",
        "其他工具",
    ]

    let toolPlatformList = [
        "Android", // 业务方
        "iOS",
        "HarmonyOS"
    ] 

    return (
        <AppContext.Provider value={{
            userInfo,
            toolCategoryList,
            toolPlatformList
        }}
        >
            <div className="app">
                <div className="app-body">
                    <Header hideHeaderBg={hideHeaderBg}/>
                    {children}
                    <BackTop style={backToTopStyle}/>
                </div>
                {!hideFooter &&
                    <Footer />
                }
            </div>
        </AppContext.Provider>
    );
}

Page.defaultProps = {
    hideFooter: false,
    hideHeaderBg: false,
}

Page.propTypes = {
    children: PropTypes.node.isRequired,
    hideFooter: PropTypes.bool.isRequired,
    hideHeaderBg: PropTypes.bool.isRequired,
};
